<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { Locales, ProjectModuleDto } from '@/services/types/api.types';
import { useConfigurationStore } from '@/stores/configurations.store';
import LocalizedEditor from '@/components/base/LocalizedEditor.vue';
import LocalizedInput from '../LocalizedInput.vue';
import StandardInput from '../StandardInput.vue';
import StandardToggle from '../StandardToggle.vue';

const { t } = useI18n();
const isProjectTOCEnabled = useConfigurationStore().isFeatureEnabled('projectTOC');

const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleDto;
}>();
</script>

<template>
  <div class="module-question-answer">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <q-field :label="t('global.label.description')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.description"
          :label="t('global.label.description')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <q-field :label="t('global.label.thank-you-message')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.thankYouMessage"
          :label="t('global.label.thank-you-message')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <localized-input
      name="config.noAnswersMessage"
      :label="t('global.label.no-answers-message')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <standard-input
      name="config.maxLength"
      :label="t('project-module.feedback.max-length')"
      type="number"
      outlined
      :min="1"
      :clearable="true"
    />
    <standard-toggle name="config.highlight" :label="t('project-module.admin.highlight')" outlined />
    <standard-toggle
      v-if="isProjectTOCEnabled"
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
  </div>
</template>
